var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDirect = function SvgDirect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m31.68 22.13 1.747 3.54 3.907.568-2.827 2.756.667 3.89-3.494-1.836-3.494 1.837.667-3.891-2.827-2.756 3.907-.567zM6.654 22.13l-1.747 3.54L1 26.239l2.827 2.756-.668 3.89 3.495-1.836 3.494 1.837-.668-3.891 2.827-2.756-3.906-.567zM14.267 5.9a4.9 4.9 0 1 0 9.8 0 4.9 4.9 0 0 0-9.8 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11.629 20.599h15.076v-2.261a7.538 7.538 0 1 0-15.076 0zM19.166 26.58l1.747 3.54 3.907.567-2.827 2.756.667 3.89-3.494-1.837-3.494 1.837.668-3.89-2.827-2.756 3.906-.567z"
  })));
};
export default SvgDirect;